import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ListaPeriodosCalculosService = async (values) => {
	try {
		return await instance.Backend.post("/Indicador/ListaPeriodosCalculos", values, customConfig);
	} catch (error) {
		console.log(error);
	}
};

export { ListaPeriodosCalculosService };
